<template>
  <ion-app>
    <Header />
    <ion-split-pane
      v-if="authorized"
      content-id="main-content"
      when="md"
    >
      <MainMenu />
      <ion-router-outlet id="main-content" />
    </ion-split-pane>
    <Auth
      v-else
      id="main-content"
    />
  </ion-app>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Layout/Header';
import MainMenu from '@/components/Layout/Menu';
import Auth from '@/components/Auth/AuthPage';

export default {
  components: { Auth, Header, MainMenu },
  computed: {
    ...mapState('auth', ['authorized', 'initialized']),
  },
  watch: {
    initialized(isInitialized) {
      if (isInitialized) {
        document.getElementById('loading_startup').style.display = 'none';
      } else {
        document.getElementById('loading_startup').style.display = 'block';
      }
    },
  },
};

</script>

<style lang="scss" scoped>
  ion-split-pane {
    --border: none;
  }
  .split-pane-md.split-pane-visible>.split-pane-side {
    max-width: 300px;
  }

  ion-router-outlet, ion-menu {
    margin-top: 56px;
  }

.loadingSpinner {
  margin: auto;
}
</style>

<style lang="scss">
  .toast-error .button-inner {
    color: #36454f;
  }
</style>
